import { Link } from "react-router-dom";
import { EMAIL, MAILTO, NAV_LINKS, PHONE_DISPLAY, PHONE_TEL } from "@/data/site";
import { useSectionNav } from "@/hooks/useSectionNav";

const Footer = () => {
  const go = useSectionNav();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-obsidian" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-16 sm:grid-cols-2 sm:px-8 lg:grid-cols-4">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center border border-blue-500/50 font-display text-xl font-bold text-white">F</span>
            <span className="leading-none">
              <span className="block font-display text-xl font-bold uppercase tracking-[0.08em] text-white">Freedom</span>
              <span className="mt-1 block font-mono text-[9px] font-semibold uppercase tracking-[0.3em] text-slate-400">Mobile Auto Detailing</span>
            </span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            Mobile Interior &amp; Exterior Detailing
            <br />
            Gap, Pennsylvania
          </p>
          <p className="mt-2 text-sm text-slate-500">
            Serving surrounding Lancaster County &amp; Chester County communities.
          </p>
        </div>
        <nav aria-label="Footer">
          <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">Navigate</p>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button onClick={() => go(l.id)} className="text-sm text-slate-300 transition-colors hover:text-blue-400" data-testid={`footer-link-${l.id}`}>
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">Contact</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <a href={PHONE_TEL} className="text-slate-300 transition-colors hover:text-blue-400" data-testid="footer-phone-link">{PHONE_DISPLAY}</a>
            </li>
            <li>
              <a href={MAILTO} className="break-all text-slate-300 transition-colors hover:text-blue-400" data-testid="footer-email-link">{EMAIL}</a>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">Legal</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/privacy-policy" className="text-slate-300 transition-colors hover:text-blue-400" data-testid="footer-privacy-link">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/service-disclaimer" className="text-slate-300 transition-colors hover:text-blue-400" data-testid="footer-disclaimer-link">Terms / Service Disclaimer</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-5 py-6 sm:flex-row sm:items-center sm:px-8">
          <p className="font-mono text-[11px] tracking-wider text-slate-500" data-testid="footer-copyright">
            © {year} Freedom Mobile Auto Detailing. All Rights Reserved.
          </p>
          <p className="font-mono text-[11px] tracking-wider text-slate-600">Mobile car detailing — Gap, Paradise, Parkesburg &amp; nearby towns</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
